export default __webpack_public_path__ + "static/rsz_article-441732aa5142e3fbed0cef6ce05c6f4d.png";